import React from 'react';
import './TourSharePublicWarning.scss';

const TourSharePublishWarning = ({ children }) => (
  <article className="share-publish-warning">{children}</article>
);

export default TourSharePublishWarning;
